import { useEffect, useRef } from "react";

const FOCOS = 'a[href],button,input,select,textarea,[tabindex]:not([tabindex="-1"])';

/**
 * Modal accesible: al abrir manda el foco adentro, Tab/Shift+Tab se quedan dentro, Esc cierra y al cerrar el foco vuelve a quien lo abrió.
 * `ref` = el contenedor con role="dialog" aria-modal="true".
 */
export default function useModalFoco(ref, onCerrar) {
  const cerrarRef = useRef(onCerrar);
  cerrarRef.current = onCerrar;
  useEffect(() => {
    const raiz = ref.current;
    if (!raiz) return undefined;
    const disparador = document.activeElement;
    if (!raiz.hasAttribute("tabindex")) raiz.setAttribute("tabindex", "-1");
    const lista = () => Array.from(raiz.querySelectorAll(FOCOS)).filter((el) => !el.disabled && el.getAttribute("aria-hidden") !== "true");
    (lista()[0] || raiz).focus();
    const onKey = (e) => {
      if (e.key === "Escape") { e.stopPropagation(); cerrarRef.current?.(); return; }
      if (e.key !== "Tab") return;
      const l = lista();
      if (!l.length) { e.preventDefault(); raiz.focus(); return; }
      const primero = l[0];
      const ultimo = l[l.length - 1];
      const act = document.activeElement;
      if (!raiz.contains(act)) { e.preventDefault(); primero.focus(); }
      else if (e.shiftKey && (act === primero || act === raiz)) { e.preventDefault(); ultimo.focus(); }
      else if (!e.shiftKey && act === ultimo) { e.preventDefault(); primero.focus(); }
    };
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("keydown", onKey);
      if (disparador && typeof disparador.focus === "function" && document.contains(disparador)) disparador.focus();
    };
  }, [ref]);
}
